<section class="section-admin-wrap">
    <section class="section">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                    <h1 class="heading parking-fee-heading">{{selectedDay}}</h1>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-sm-12 col-md-3 col-lg-2 col-xl-2">
                    <div class="leftmenu">
                        <ul class="unorder-list">

                            <li routerLinkActive="active" class="active"><a routerLink="/shuttle-report">Shuttle
                                    Reports</a></li>
                            <li routerLinkActive="active" class="active"><a
                                    routerLink="/reservations-detail">Reservations</a></li>

                        </ul>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-9 col-lg-10 col-xl-10">
                    <div class="property-tab">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3"><label>Property</label></div>
                            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                <select class="form-control" [(ngModel)]="property_id"
                                    [ngModelOptions]="{standalone: true}" (change)="selectChangeHandler($event)">
                                    <option *ngFor="let item of properties" value="{{ item.id }}"> {{ item.property_name
                                        }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="card card-bottom">
                        <div class="card-header">
                            Rates
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <form [formGroup]="rateForm">
                                    <table class="table  table-center table-rate-tab">
                                        <tbody>
                                            <tr>
                                                <td colspan="4">
                                                    <div class="form-row">
                                                        <div
                                                            class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 welcometext">
                                                            Welcome:<span> {{ me?.first_name }}</span></div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th colspan="2">Change Default Rate <input type="text"
                                                        name="indoorvalet" formControlName="defaultRate"
                                                        class="small-input"></th>
                                                <!-- <td class="text-right"><button type="button" class="btn btn-sm btn-success" (click)="changeDefaultRate()">Change Default Rate</button></td> -->
                                            </tr>
                                            <tr>
                                                <th colspan="2">Change Rates</th>
                                                <td colspan="2" class="text-right"><button type="button"
                                                        class="btn btn-sm btn-success" (click)="add()">Add More
                                                    </button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table  table-center table-light table-bordered ">
                                        <thead>
                                            <tr>
                                                <th>Number Of Person</th>
                                                <th>Rate</th>
                                                <th>Tax</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container formArrayName="rate"
                                                *ngFor="let item of rateForm.get('rate')['controls']; let i = index;">
                                                <ng-container [formGroupName]="i">
                                                    <tr>
                                                        <td>
                                                            <select formControlName="no_of_person"
                                                                (change)="personsChange($event)">
                                                                <option value="">Select</option>
                                                                <option *ngFor="let item of totalPersons"
                                                                    value="{{item}}">{{item}}</option>
                                                            </select>
                                                            <div *ngIf="isValid && rate.controls[i].get('no_of_person').errors"
                                                                class="help-block">
                                                                <div
                                                                    *ngIf="rate.controls[i].get('no_of_person').errors?.required">
                                                                    Persons is required</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <input type="text" formControlName="rate"
                                                                class="small-input">
                                                            <div *ngIf="isValid && rate.controls[i].get('rate').errors"
                                                                class="help-block">
                                                                <div
                                                                    *ngIf="rate.controls[i].get('rate').errors?.required">
                                                                    Rate is required</div>
                                                                <div
                                                                    *ngIf="rate.controls[i].get('rate').errors?.pattern">
                                                                    Invalid format</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <input type="text" formControlName="tax"
                                                                class="small-input">
                                                            <div *ngIf="isValid && rate.controls[i].get('tax').errors"
                                                                class="help-block">
                                                                <div
                                                                    *ngIf="rate.controls[i].get('tax').errors?.required">
                                                                    Tax is required</div>
                                                                <div
                                                                    *ngIf="rate.controls[i].get('tax').errors?.pattern">
                                                                    Invalid format</div>
                                                            </div>
                                                        </td>
                                                        <td><button type="button" class="btn btn-sm btn-warning"
                                                                *ngIf="i" (click)="remove(i)">Remove</button></td>
                                                    </tr>
                                                </ng-container>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                </form>
                            </div>
                            <div class="col-12 col-sm-12 col-lg-12 col-sl-12 button-center">
                                <button class="btn btn-default" type="button" (click)="submitRate()">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>